import * as React from "react";
import { useIsExpressPaymentMethodSupported } from "./use-is-express-payment-method-supported.js";
import { PaymentMethod } from "../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const useIsExpressPaypalSupportedForCart = (cartId) => {
  const [getIsPaypalSupportedForCart, { isPaymentMethodSupported, called, loading, error }] = useIsExpressPaymentMethodSupported(PaymentMethod.PAYPAL);
  React.useEffect(() => {
    if (cartId) {
      getIsPaypalSupportedForCart(cartId);
    }
  }, [getIsPaypalSupportedForCart, cartId]);
  return {
    isExpressPaypalSupported: isPaymentMethodSupported,
    loading,
    called,
    error
  };
};
export {
  useIsExpressPaypalSupportedForCart
};
//# sourceMappingURL=use-is-express-paypal-supported.js.map
